import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Alert, Checkbox, Stack, Typography } from '@mui/material';

export const AutoRenewContractPreferences: React.FC = () => {
  const preferences = getAutoRenewContractPreferences();

  return (
    <Stack
      sx={{
        alignItems: "center",
        justifyContent: "center",
        py: 3,
        px: 0
      }}>
      <Stack spacing={2} sx={{ width: '100%', maxWidth: 594 }}>
        {preferences.map(({ label, description }) => (
          <Stack key={label} direction="row" spacing={1} sx={{
            alignItems: "flex-start"
          }}>
            <Checkbox size="small" checked={true} />
            <Stack spacing={0.5}>
              <Typography variant="body2" sx={{
                color: "text.primary"
              }}>
                {label}
              </Typography>
              <Typography variant="caption" sx={{
                color: "text.secondary"
              }}>
                {description}
              </Typography>
            </Stack>
          </Stack>
        ))}

        <Alert
          icon={<InfoOutlinedIcon />}
          severity="info"
          sx={{
            backgroundColor: '#e7f2ff',
            color: 'text.primary',
            borderRadius: 1,
            '& .MuiAlert-icon': {
              color: 'text.primary',
            },
          }}
        >
          You can turn off auto-renew at any time before the contract ends.
        </Alert>
      </Stack>
    </Stack>
  );
};

function getAutoRenewContractPreferences() {
  return [
    {
      label: 'Usage limits and commitment rollover',
      description:
        "If there's unused committed spend in the current term, it will roll into the next contract period.",
    },
    {
      label: 'Retain pricing tier',
      description: 'Renew and keep the last usage-based tier pricing.',
    },
  ];
}
